<template>
  <div class="login-slider" @mouseenter="pauseAutoPlay" @mouseleave="resumeAutoPlay">
    <div class="slider-viewport">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="slider-slide"
        :class="{ active: index === currentIndex }"
      >
        <img
          :src="slide.image"
          :alt="slide.title"
          @error="handleImageError"
        />
        <div class="slide-overlay"></div>
        <div class="slide-logo">
          <svg width="57" height="68" viewBox="0 0 57 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.7766 65.0116C25.7082 64.9968 17.5564 56.8836 17.5614 46.8811V42.1613H35.7742C43.2447 42.1564 50.1634 38.2517 53.9919 31.8772V46.9132C53.9819 56.9034 45.8327 64.9992 35.7766 65.0091M14.5558 42.1613V46.9132C14.5558 48.6716 14.777 50.4227 15.2146 52.1268L5.14114 42.1613H14.5558ZM3.00563 39.1754V5.09265L11.5054 13.5417C13.4644 15.478 14.5632 18.1132 14.5558 20.8596V39.1754H3.00563ZM53.9894 21.0794C53.9745 31.0795 45.8078 39.1779 35.7418 39.1754H17.5614V20.8596C17.5714 17.3229 16.1543 13.927 13.631 11.4325L5.12871 2.98347H35.7742C45.8302 2.99335 53.9795 11.0892 53.9894 21.0794ZM56.995 21.0794C56.9801 9.44191 47.4884 0.0123488 35.7742 0H3.207C1.43693 0 0.00248604 1.42505 0 3.18353V40.6696C0 41.0672 0.159107 41.4476 0.442516 41.7267L21.3924 62.4554L21.4247 62.4258C30.0389 70.3092 43.4535 69.7634 51.389 61.2082C55.0087 57.3059 57.0124 52.1886 57 46.8811V21.0794" fill="white" fill-opacity="0.1"/>
          </svg>
        </div>
        <div class="slide-content">
          <h2 class="slide-title">{{ slide.title }}</h2>
        </div>
      </div>
    </div>

    <div class="slider-controls">
      <button class="slider-arrow slider-arrow--prev" @click="prev" aria-label="Slide anterior">
        <i class="fa fa-chevron-left"></i>
      </button>
      <button class="slider-arrow slider-arrow--next" @click="next" aria-label="Proximo slide">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="slider-indicators">
      <button
        v-for="(_, index) in slides"
        :key="index"
        class="slider-indicator"
        :class="{ active: currentIndex === index }"
        @click="goTo(index)"
        :aria-label="'Ir para slide ' + (index + 1)"
      />
    </div>
  </div>
</template>

<script>
import slide1 from "./../assets/img/slider/slide-1.png";
import slide2 from "./../assets/img/slider/slide-2.png";
import slide3 from "./../assets/img/slider/slide-3.png";

export default {
  name: "LoginSlider",
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      isPaused: false,
      slides: [
        {
          image: slide1,
          title:
            "O Dicomp Direct é uma plataforma de venda intermediada pela sua empresa, criada para ampliar suas oportunidades de negócio."
        },
        {
          image: slide2,
          title:
            "Você, revenda ou integrador, mantém o relacionamento e a negociação com seu cliente, enquanto a Dicomp apoia a operação com um amplo portfólio e entrega direta ao destino."
        },
        {
          image: slide3,
          title:
            "Você negocia com seu cliente, e a Dicomp apoia a operação com portfólio, estrutura e entrega."
        }
      ]
    };
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    startAutoPlay() {
      this.stopAutoPlay();
      if (!this.isPaused) {
        this.intervalId = setInterval(() => {
          this.next();
        }, 5000);
      }
    },
    stopAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    goTo(index) {
      this.currentIndex = index;
      this.startAutoPlay();
    },
    pauseAutoPlay() {
      this.isPaused = true;
      this.stopAutoPlay();
    },
    resumeAutoPlay() {
      this.isPaused = false;
      this.startAutoPlay();
    },
    handleImageError(event) {
      if (event.target.src !== this.slides[0].image) {
        event.target.src = this.slides[0].image;
      }
    }
  }
};
</script>

<style scoped>
.login-slider {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 30px;
  background: #1a1f24;
}

.slider-viewport {
  width: 100%;
  height: 100%;
  position: relative;
}

.slider-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
}

.slider-slide.active {
  opacity: 1;
  z-index: 1;
}

.slider-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(26, 31, 36, 0.1) 0%,
    rgba(26, 31, 36, 0.3) 40%,
    rgba(26, 31, 36, 0.85) 100%
  );
  z-index: 1;
}

.slide-logo {
  position: absolute;
  top: 5%;
  left: 5%;
  width: 48px;
  height: 56px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.slide-logo svg,
.slide-logo svg path {
    fill: rgb(253, 253, 253) !important;
    opacity: 1 !important;
    fill-opacity: 1 !important;
}

.slide-content {
    position: absolute;
    bottom: 14%;
    left: 11%;
    right: 13%;
    color: #ffffff;
    z-index: 2;
}

.slide-title {
    font-size: 33px;
    font-weight: 600;
    text-transform: uppercase;
    line-height: 1.05;
    margin: 0;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.slider-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  z-index: 3;
  pointer-events: none;
}

.slider-arrow {
  pointer-events: auto;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.6);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-arrow i {
  font-size: 14px;
}

.slider-arrow:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.4);
  color: #ffffff;
}

.slider-arrow:active {
  transform: scale(1);
}

.slider-indicators {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 3;
}

.slider-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.6);
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.slider-indicator.active {
  background: #ffffff;
  border-color: #ffffff;
  transform: scale(1.15);
}

.slider-indicator:hover:not(.active) {
  background: rgba(255, 255, 255, 0.4);
  border-color: rgba(255, 255, 255, 0.8);
}
</style>